import { getI18n } from 'react-i18next';

export const VALIDATION_MEMBER_EMPTY_NAME = 'validation.member.emptyName';
export const VALIDATION_MEMBER_INVALID_NAME_LENGTH = 'validation.member.invalidNameLength';
export const VALIDATION_MEMBER_EMPTY_MEMBER_ID = 'validation.member.emptyMemberId';
export const VALIDATION_MEMBER_INVALID_MEMBER_ID = 'validation.member.invalidMemberId';
export const VALIDATION_MEMBER_INVALID_EMAILS_LENGTH = 'validation.member.invalidEmailsLength';
export const VALIDATION_MEMBER_INVALID_EMAILS = 'validation.member.invalidEmails';
export const VALIDATION_MEMBER_INVALID_PHONE_LENGTH = 'validation.member.invalidPhoneLength';
export const VALIDATION_MEMBER_INVALID_PHONE = 'validation.member.invalidPhone';
export const VALIDATION_MEMBER_INVALID_BALANCING_GROUP = 'validation.member.invalidBalancingGroup';
export const VALIDATION_MEMBER_MEMBER_ID_ALREADY_IN_USE = 'validation.member.memberIdAlreadyInUse';
export const VALIDATION_MEMBER_NAME_ALREADY_IN_USE = 'validation.member.nameAlreadyInUse';
export const VALIDATION_MEMBER_NO_CHANGE_AUCTIONS_RUNNING = 'member.noChangeWhenAuctionsRunning';
export const VALIDATION_MEMBER_NO_DEACTIVATION_ACTIVE_IN_AUCTIONS = 'member.noDeactivationWhenActiveInAuctions';
export const VALIDATION_MEMBER_NO_DEACTIVATION_WHEN_AUCTION_LIMIT_DEFINED = 'member.noDeactivationWhenAuctionLimitDefined';
export const VALIDATION_MEMBER_EMPTY_MEMBER_TYPE = 'validation.member.emptyMemberType';
export const VALIDATION_MEMBER_INVALID_MEMBER_TYPE = 'validation.member.invalidMemberType';
export const VALIDATION_MEMBER_NOT_EMPTY_BALANCING_GROUP = 'validation.member.notEmptyBalancingGroup';
export const VALIDATION_MEMBER_EMPTY_BALANCING_GROUP = 'validation.member.emptyBalancingGroup';
export const VALIDATION_MEMBER_INVALID_ZONE = 'validation.member.invalidZone';
export const VALIDATION_MEMBER_EMPTY_ZONE = 'validation.member.emptyZone';
export const VALIDATION_MEMBER_NOT_EMPTY_PAYMENT_CURRENCY = 'validation.member.notEmptyPaymentCurrency';
export const VALIDATION_MEMBER_INVALID_PAYMENT_CURRENCY = 'validation.member.invalidPaymentCurrency';
export const VALIDATION_MEMBER_NOT_EMPTY_FOREIGN_CURRENCY_ALLOWED = 'validation.member.notEmptyForeignCurrencyAllowed';
export const VALIDATION_MEMBER_NOT_EMPTY_EU_AUCTIONEER = 'validation.member.notEmptyEuAuctioneer';
export const VALIDATION_MEMBER_IMMUTABLE_MEMBER_TYPE = 'validation.member.immutableMemberType';
export const VALIDATION_MEMBER_IMMUTABLE_MEMBER_ID = 'validation.member.immutableMemberId';
export const VALIDATION_MEMBER_IMMUTABLE_BALANCING_GROUP = 'validation.member.immutableBalancingGroup';
export const ERROR_MEMBER_NOT_FOUND = 'member.notFound';
export const ERROR_MEMBER_SUSPEND_ROLE_NOT_ALLOWED = 'member.suspend.roleNotAllowed';
export const ERROR_MEMBER_INVALID_SORT_KEY = 'member.sort.invalidField';

export const createMemberErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) { // NOSONAR javascript:S1479
        case VALIDATION_MEMBER_EMPTY_NAME:
            result = i18n.t('members.error.member-empty-name');
            break;
        case VALIDATION_MEMBER_INVALID_NAME_LENGTH:
            result = i18n.t('members.error.member-invalid-name-length', { maxLength: params[0] });
            break;
        case VALIDATION_MEMBER_EMPTY_MEMBER_ID:
            result = i18n.t('members.error.member-empty-member-id');
            break;
        case VALIDATION_MEMBER_INVALID_MEMBER_ID:
            result = i18n.t('members.error.member-invalid-member-id');
            break;
        case VALIDATION_MEMBER_INVALID_EMAILS_LENGTH:
            result = i18n.t('members.error.member-invalid-emails-length', { maxLength: params[0] });
            break;
        case VALIDATION_MEMBER_INVALID_EMAILS:
            result = i18n.t('members.error.member-invalid-emails');
            break;
        case VALIDATION_MEMBER_INVALID_PHONE_LENGTH:
            result = i18n.t('members.error.member-invalid-phone-length', { maxLength: params[0] });
            break;
        case VALIDATION_MEMBER_INVALID_PHONE:
            result = i18n.t('members.error.member-invalid-phone');
            break;
        case VALIDATION_MEMBER_INVALID_BALANCING_GROUP:
            result = i18n.t('members.error.member-invalid-balancing-group');
            break;
        case VALIDATION_MEMBER_MEMBER_ID_ALREADY_IN_USE:
            result = i18n.t('members.error.member-id-already-in-use');
            break;
        case VALIDATION_MEMBER_NAME_ALREADY_IN_USE:
            result = i18n.t('members.error.member-name-already-in-use');
            break;
        case VALIDATION_MEMBER_NO_CHANGE_AUCTIONS_RUNNING:
            result = i18n.t('members.error.member-change-auctions-running');
            break;
        case VALIDATION_MEMBER_NO_DEACTIVATION_ACTIVE_IN_AUCTIONS:
            result = i18n.t('members.error.member-deactivation-active-in-auctions');
            break;
        case VALIDATION_MEMBER_NO_DEACTIVATION_WHEN_AUCTION_LIMIT_DEFINED:
            result = i18n.t('members.error.member-deactivation-auction-limit-defined');
            break;
        case VALIDATION_MEMBER_EMPTY_MEMBER_TYPE:
            result = i18n.t('members.error.member-empty-member-type');
            break;
        case VALIDATION_MEMBER_INVALID_MEMBER_TYPE:
            result = i18n.t('members.error.member-invalid-member-type');
            break;
        case VALIDATION_MEMBER_NOT_EMPTY_BALANCING_GROUP:
            result = i18n.t('members.error.member-balancing-group-not-empty');
            break;
        case VALIDATION_MEMBER_EMPTY_BALANCING_GROUP:
            result = i18n.t('members.error.member-balancing-group-empty');
            break;
        case VALIDATION_MEMBER_INVALID_ZONE:
            result = i18n.t('members.error.member-invalid-zone');
            break;
        case VALIDATION_MEMBER_EMPTY_ZONE:
            result = i18n.t('members.error.member-zone-empty');
            break;
        case VALIDATION_MEMBER_NOT_EMPTY_PAYMENT_CURRENCY:
            result = i18n.t('members.error.member-payment-currency-not-empty');
            break;
        case VALIDATION_MEMBER_INVALID_PAYMENT_CURRENCY:
            result = i18n.t('members.error.member-invalid-payment-currency');
            break;
        case VALIDATION_MEMBER_NOT_EMPTY_FOREIGN_CURRENCY_ALLOWED:
            result = i18n.t('members.error.member-foreign-currency-allowed-not-empty');
            break;
        case VALIDATION_MEMBER_NOT_EMPTY_EU_AUCTIONEER:
            result = i18n.t('members.error.member-eu-auctioneer-not-empty');
            break;
        case VALIDATION_MEMBER_IMMUTABLE_MEMBER_TYPE:
            result = i18n.t('members.error.member-immutable-member-type');
            break;
        case VALIDATION_MEMBER_IMMUTABLE_MEMBER_ID:
            result = i18n.t('members.error.member-immutable-member-id');
            break;
        case VALIDATION_MEMBER_IMMUTABLE_BALANCING_GROUP:
            result = i18n.t('members.error.member-immutable-balancing-group');
            break;
        case ERROR_MEMBER_NOT_FOUND:
            result = i18n.t('members.error.member-not-found');
            break;
        case ERROR_MEMBER_SUSPEND_ROLE_NOT_ALLOWED:
            result = i18n.t('members.error.suspend-role-not-allowed', { role: params[0] });
            break;
        case ERROR_MEMBER_INVALID_SORT_KEY:
            result = i18n.t('members.error.member-invalid-sort-key', { sortKey: params[0] });
            break;
        default:
            result = undefined;
    }
    return result;
};
